import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { activated } from '../../redux/slices/Auth/login'
import { Modal } from '@mui/material'
import Login from '../Login'

const LoginModal = props => {
  const dispatch = useDispatch()
  const _loginState = useSelector(state => state.login)

  const handleCloseModal = () => dispatch(activated(false))

  if (_loginState.authenticated?.auth) return null

  return (
    <Modal
      open={_loginState.visible}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      componentsProps={{ backdrop: { sx: { backdropFilter: 'blur(2px)' } } }}
      disableEscapeKeyDown>
      <>
        <Login modal />
      </>
    </Modal>
  )
}

export default LoginModal
